import FuseLoadable from '@fuse/components/FuseLoadable/FuseLoadable'

export const RichiesteConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: '/richiesta/:id',
      component: FuseLoadable({
        loader: () => import('./Richieste')
      })
    }
  ]
}
